<template>
	<p-card class="tw-text-center">
		<stepper :steps="stepLabels" :current-step="currentStep"></stepper>
	</p-card>
</template>

<script>
import Stepper from '../../shared/components/ui/stepper/Stepper';
import PCard from '../../shared/components/ui/Card/p-card';

export default {
	name: 'three-sixty-evaluation-stepper',
	components: { PCard, Stepper },
	props: {
		currentStep: {
			default: () => 1,
		},
		stepLabels: {
			default: () => [],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/three-sixty-evaluation-stepper.vue